export var ADMIN_PATHS = {
    SYSTEM: '/system',
    TABLETS: '/tablets',
    CLIENT: '/clients',
    LOGS: '/logs',
    LOG_CHAT: '/logs/chat/:chatId',
    USERS: '/users',
    STATISTICS: '/statistics',
    ESTABLISHMENTS: '/establishments',
    ESTABLISHMENTS_CREATE: '/establishments/create',
    ESTABLISHMENTS_UPDATE: '/establishments/update',
    NETWORKS: '/networks',
    CLIENTS: '/clinets',
    MENU: '/menu',
    NewSchemes: "/newSchemes",
    PROFILE_MODERATION: '/profile-moderation',
    USER_PROFILE: '/user/:userId',
    ADMIN_PROFILE: '/admin/:userId',
    CHATS: '/chats',
    SINGLE_CHAT: '/chats/:chatId',
    MY_CHATS: '/myChats',
    MY_CHAT: '/myChats/:chatId',
    EVENTS: '/events',
    NEWUSERS: '/newUsers',
    RECOMMENDATIONS: '/recommendations',
    PROMOACTIONS: '/promoActions',
    REFFS: '/reffs',
    TOGETHER_ACTIVITIES: '/together-activities',
    FEED: '/feed',
    SCREEN_ANALYTICS: '/screen-analytics',
};
